import React from 'react';
import { useField } from 'formik';
import NumberFormat from 'react-number-format';

export default function BirthdateField({
  label,
  monthFieldName,
  monthPlaceholder = 'mm',
  dayFieldName,
  dayPlaceholder = 'dd',
  yearFieldName,
  yearPlaceholder = 'yyyy'
}) {
  const [dayField, dayFieldMeta] = useField(dayFieldName);
  const [monthField, monthFieldMeta] = useField(monthFieldName);
  const [yearField, yearFieldMeta] = useField(yearFieldName);

  function FieldError({ meta }) {
    return meta.touched && meta.error ? (
      <div className="input-feedback">{meta.error}</div>
    ) : null;
  }

  return (
    <div className="form-group form-group-birthdate">
      <label className="form-label form-label-lg">{label}</label>
      <div className="form-inline">
        <NumberFormat
          type="text"
          allowNegative={false}
          decimalSeparator={false}
          className="form-control"
          placeholder={monthPlaceholder}
          {...monthField}
          isAllowed={values =>
            values.value === '' ||
            (values.floatValue <= 12 && values.floatValue > 0)
          }
        />

        <NumberFormat
          type="text"
          allowNegative={false}
          decimalSeparator={false}
          className="form-control"
          placeholder={dayPlaceholder}
          {...dayField}
          isAllowed={values =>
            values.value === '' ||
            (values.floatValue <= 31 && values.floatValue > 0)
          }
        />

        <NumberFormat
          type="text"
          allowNegative={false}
          decimalSeparator={false}
          className="form-control"
          placeholder={yearPlaceholder}
          {...yearField}
          isAllowed={values =>
            values.value === '' || values.floatValue <= new Date().getFullYear()
          }
        />
      </div>
      <FieldError meta={monthFieldMeta} />
      <FieldError meta={dayFieldMeta} />
      <FieldError meta={yearFieldMeta} />
    </div>
  );
}
